import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { CompanyInsightsService, ExportPayload, ExportRequest } from 'src/app/_services/company-insights.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { FusionChartsService } from 'src/app/_services/fusion-charts.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { TIAggRequest } from 'src/app/common-interfaces-classes/TIAggRequest';
import * as __ from 'lodash';

@Component({
    selector: 'app-compprofile-tab',
    templateUrl: './compprofile-tab.component.html',
    styleUrls: ['./compprofile-tab.component.scss'],
    standalone: false
})
export class CompprofileTabComponent implements OnInit {

  constructor(private fusionChartService: FusionChartsService, private personSearchService: PersonSearchService, private location: Location, private companyinsightsService: CompanyInsightsService,
    private filterDataHandlerService: FilterDataHandlerService, private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService, private aggService: AggregationService){ }
  companyDetails: any;
  currentCompanyName: any;
  totalFunctionResultCount: number = 0;
  functionsData: any = [];
  seniorityData: any = [];
  keyPeopleData: any = [];
  keyPeoplePDLIds: any = [];
  showLoaderForKeyPeople: boolean = false;
  allKeyPeopleData: any = [];
  alternatecompanyNames: any[] = [];
  profilesubscription: Subscription;
  departmentemptystate: Boolean = false;
  seniorityemptystate: Boolean = false;
  keyemptystate: Boolean = false;
  recentemptystate: Boolean = false;

  /** start index in function page */
  keyPeopleStartIndex: number = 0;
  /**End index in function page */
  keyPeopleEndIndex: number = 6;
  /**Number of items on each of function page */
  keyPeoplePageSize:number = 6;
  /**Current page number in function */
  keyPeopleCurrentPage: number = 1;
  /**Total items in function page*/
  keyPeopleTotalCount = 0;
  keyPeopleAggCount = 30;
  /** Subscription var */
  subscriptions: Array<Subscription> = [];
  departmentsdata: any = [];
  profiledataAI: any;
  seniorityaiData: any = [];
  insightsExportSubscription: Subscription = null;

  ngOnInit(): void {
    // this.profilesubscription = this.personSearchService.companyDetail.subscribe((response) => {
    //   this.companyDetails = response;
    //   this.recentHiresData = []
    //   this.allKeyPeopleData = []
    //   this.currentCompanyName = this.companyDetails.name;
    //   this.alternatecompanyNames =  this.companyDetails.alternative_names &&  this.companyDetails.alternative_names.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]): [this.currentCompanyName];

    //   this.recentHireCurrentPage = 1;
    //   this.recentHireStartIndex = 0;
    //   this.recentHireAggCount = 50;

    //   this.keyPeopleCurrentPage = 1;
    //   this.keyPeopleStartIndex = 0;
    //   this.keyPeopleEndIndex = 6;
      
    //   this.showLoaderForKeyPeople = true;
    //   this.getFunction();
    //   this.getSeniority();
    //   this.keyPeoplePDLIds = this.companyDetails?.recent_exec_hires?.length && this.companyDetails?.recent_exec_hires.map(x => x.pdl_id);
    //   this.getKeyPeopleData();
    //   this.getRecentHires();
    // });

    this.setCompanyDetails();
    this.fetchPageData();
    /**Fetch filter data after applying filters */
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => this.fetchPageData());
    this.subscriptions.push(filterMethodEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.companyinsightsService.insightsExportRequestEvent.subscribe((requestData: ExportRequest) => {
      if(requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);
  }

  setCompanyDetails() {
    this.companyDetails = this.companyinsightsService.fetchCompanyData;
    this.currentCompanyName = this?.companyDetails?.name;
    this.alternatecompanyNames = this.companyDetails?.alternative_names?.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]) : [this.currentCompanyName];
    this.keyPeoplePDLIds = this.companyDetails?.recent_exec_hires?.length && this.companyDetails?.recent_exec_hires.map(x => x.pdl_id);

  }

  fetchPageData() {
     this.getFunction();
      this.getSeniority();
      this.getKeyPeopleData();
      this.personSearchService.setCompanyInsightsFilterAI(this.companyDetails);
  }

  getFunction() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "function";
    aggReq.aggregatescount = 50;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      this.totalFunctionResultCount = response.data.totalresultscount;
      this.functionsData = response.data.aggregations.function.slice(0, 5);
      this.getprofileai(response.data.aggregations.function, 'departments')
      this.departmentemptystate = true;
      
      const count = this.functionsData.map(x => x.doc_count).reduce((a, b) => a + b, 0);
      const othersCount = count - this.totalFunctionResultCount;
      if (othersCount) {
        this.functionsData.push({
          key: "Others",
          doc_count: othersCount,
        })
      }
      
      this.functionsData = this.fusionChartService.functionsChart(this.functionsData);
    });
  }

  getSeniority() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "seniority";
    aggReq.aggregatescount = 50;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      this.seniorityData = response.data.aggregations.seniority.slice(0, 5);
      this.getprofileai(response.data.aggregations.seniority, 'seniority')
      this.seniorityemptystate = true;

      this.seniorityData = this.fusionChartService.seniorityChart(this.seniorityData);

    });
  }

  getKeyPeopleData() {
    if(this.keyPeoplePDLIds?.length) {
      this.showLoaderForKeyPeople = true;
      this.aggReqObjectHandlerService.setShareRequestObject(new TIAggRequest());
      const requestObject = this.aggService.getRequestWithFilters();
      requestObject.companies = this.alternatecompanyNames;
      requestObject.companyids = [this.companyDetails.id];
      requestObject['calledvia'] = 'companypages';
      requestObject['sendkeypeople'] = true;
      this.personSearchService.getPersonSearchRecommendCandidates(requestObject).subscribe((response) => {
        if(response && response?.data?.results){
          const tempData = response.data.results;
          this.allKeyPeopleData = tempData;
          this.keyPeopleTotalCount = tempData.length;
          this.keyPeopleData = tempData.slice(this.keyPeopleStartIndex, this.keyPeopleEndIndex);
          this.showLoaderForKeyPeople = false;
          this.keyemptystate = true;
        }
      });
    }

  }

  convertToTitleCase(stringName){
    stringName = stringName?.toLowerCase()?.split(' ');
    for(let i = 0;i<stringName?.length;i++){
      stringName[i] = stringName[i].charAt(0).toUpperCase() + stringName[i].slice(1);
    }
    return stringName?.join(' ');
  }

  /**
   * Function set the start and end of key pepole data according to page number
   * @param index page number in pagination
   */
  setPageKeyPeople(index: number){
    this.keyPeopleStartIndex = (index - 1) * this.keyPeoplePageSize;
    this.keyPeopleEndIndex = this.keyPeopleStartIndex + this.keyPeoplePageSize;
    this.keyPeopleCurrentPage = index;
    this.getKeyPeopleData();
  }

  /**
   * destroy subscriptions of filters
   */
   ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Share data with parent to initiate insights-export
   * @param requestData 
   */
  shareDataForInsightsExport(requestData: ExportRequest) {
    if(requestData?.data?.currentTab !== 'profile') return;

    // functions chart config
    const functionChart = { renderAt: 'functionsChart', dataSource: __.cloneDeep({ ...this.functionsData }) };
    functionChart['dataSource']['chart']['showLabels'] = "1";
    functionChart['dataSource']['chart']['showValues'] = "1";
    functionChart['dataSource']['chart']['useEllipsesWhenOverflow'] = "0";
    functionChart['type'] = functionChart['dataSource']['type'];
    delete functionChart?.['dataSource']?.['type'];
    delete functionChart?.['dataSource']?.['width'];
    delete functionChart?.['dataSource']?.['chart']?.['width'];
    delete functionChart?.['dataSource']?.['height'];
    delete functionChart?.['dataSource']?.['chart']?.['height'];
    delete functionChart?.['dataSource']?.['chart']?.['renderAt'];

    // seniority chart config
    const seniorityChart = { renderAt: 'seniorityChart', dataSource: __.cloneDeep({ ...this.seniorityData }) };
    seniorityChart['dataSource']['chart']['showLabels'] = "1";
    seniorityChart['dataSource']['chart']['showValues'] = "1";
    seniorityChart['dataSource']['chart']['useEllipsesWhenOverflow'] = "0";
    seniorityChart['type'] = 'doughnut2d';
    delete seniorityChart?.['dataSource']?.['type'];
    delete seniorityChart?.['dataSource']?.['width'];
    delete seniorityChart?.['dataSource']?.['chart']?.['width'];
    delete seniorityChart?.['dataSource']?.['height'];
    delete seniorityChart?.['dataSource']?.['chart']?.['height'];
    delete seniorityChart?.['dataSource']?.['chart']?.['renderAt'];

    const payloadForInsightsExport: ExportPayload = {
      tab: 'profile',
      companydetails: this.companyDetails,
      totalresultcount: this.totalFunctionResultCount,
      chartdetails: [].concat(this.functionsData?.data?.length ? functionChart : []).concat(this.seniorityData?.data?.length ? seniorityChart : [])
    }
    this.companyinsightsService.sendInsightsExportData(payloadForInsightsExport);
  }

  getprofileai(data, type) {
    if(type == 'departments') {
     this.departmentsdata = data.map(x=>{
        let res: any ={};
        res['Department'] = x.key;
        res['Talent Count'] = x.doc_count;
       
        return res;
      })
    } if(type == 'seniority') {
      this.seniorityaiData = data.map(x=>{
        let res:any = {};
        res['Seniority'] = x.key;
        res['Talent Count'] = x.doc_count;
        return res;
      })
    } 
    
    this.profiledataAI = {
      departments: this.departmentsdata,
      seniority: this.seniorityaiData
    } 
    if(this.departmentsdata?.length == 0 && this.seniorityaiData?.length == 0)
      this.profiledataAI = null;
  }
}
